import React, { useEffect, useState } from 'react';
import { useStoreActions, useStoreState } from 'easy-peasy';
import { Helmet } from 'react-helmet';
import { Button } from '@mui/material';
import { PhoneAuthProvider, unlink } from 'firebase/auth';
import { useNavigate } from 'react-router-dom';

import Loader from '../../../components/loader/Loader';
import { fetchFieldsFromDb } from './profile.service';
import toast from 'react-hot-toast';
import { auth } from '../../../helper/firebase.helper';

const Profile = () => {
  const [fields, setFields] = useState(null);
  const [groupedFields, setGroupedFields] = useState({});
  const [isLoading, setLoading] = useState(false);
  const setUser = useStoreActions((actions) => actions.setUser);

  const navigate = useNavigate();

  const user = useStoreState((state) => state.user);
  // console.log(user);
  const groupFieldsBySection = (fields) => {
    return fields.reduce((acc, field) => {
      const section = field.section || 'Other';
      if (!acc[section]) {
        acc[section] = [];
      }
      acc[section].push(field);
      return acc;
    }, {});
  };

  const unlinkPhoneNumber = async () => {
    await toast.promise(unlink(auth.currentUser, PhoneAuthProvider.PROVIDER_ID), {
      loading: 'Unlinking phone number',
      success: 'Successfully unlinked phone number',
      error: (err) => `Failed to unlink phone number ${err.message}`
    });
    await auth.currentUser.reload();
    setUser(auth.currentUser);
  };

  useEffect(() => {
    setLoading(true);
    const fetchData = async () => {
      if (user?.orgId) {
        const fetchedFields = await fetchFieldsFromDb(user.orgId);
        setFields(fetchedFields);
        setGroupedFields(groupFieldsBySection(fetchedFields));
        setLoading(false);
      }
      setLoading(false);
    };

    fetchData();
  }, [user]);

  return (
    <div className="profile-wrapper">
      <Helmet>
        <title>Profile - DeTalks</title>
      </Helmet>
      {isLoading ? (
        <Loader />
      ) : (
        <div className="details-div">
          <p>{user.displayName ? `Name - ${user.displayName}` : null}</p>
          <p className="margin-top--sm">{user.email ? `Email - ${user.email}` : null}</p>
          <p className="margin-top--sm">
            {user.phoneNumber ? (
              <div className="flex-container align-center">
                <div style={{ marginRight: '10px' }}>Number - {user.phoneNumber}</div>
                <Button size="small" variant="outlined" color="error" onClick={unlinkPhoneNumber}>
                  Unlink
                </Button>
              </div>
            ) : (
              <Button
                size="small"
                variant="outlined"
                onClick={() => navigate('/register/register-number')}>
                Add Phone Number
              </Button>
            )}
          </p>
        </div>
      )}

      {/* {Object.keys(groupedFields).map((section, index) => (
        <AccordionSection
          key={section}
          fields={fields}
          groupedFields={groupedFields}
          section={section}
          setLoading={setLoading}
        />
      ))}
      <LegalForms /> */}
      <style jsx>{`
        .profile-wrapper {
          min-height: 90vh;
          padding: 20px;
        }
        .details-div {
          border-bottom: 1px solid var(--border-gray);
          padding-bottom: 20px;
        }
      `}</style>
    </div>
  );
};

export default Profile;
